// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBeer = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M5.024 1.782L6 1h11l.966.784.01-.002a20 20 0 01-.157 9.372l-.487 1.88a26 26 0 00-.832 6.528V22l-1 1h-8l-1-1v-2.438c0-2.202-.28-4.396-.832-6.528l-.487-1.88a20 20 0 01-.157-9.372M16.181 3H6.819a18 18 0 00-.256 4h9.875a18 18 0 00-.257-4m.049 6H6.77q.135.833.347 1.652l.487 1.88c.595 2.296.896 4.658.896 7.03V21h6v-1.438c0-2.372.301-4.734.896-7.03l.487-1.88A18 18 0 0016.23 9"
    />
  );
export default SvgIconBeer;
